// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1xd9X","question":"Question_question__26bIy","description":"Question_description__2zDHJ"};